import { createReducer, on } from '@ngrx/store';
import { UserModel } from './common.models';
import * as CommonActions from './common.actions';
import { ConfigurationModel } from './common.models';
import {createUidSuccess} from "@dcs-workspace/shared";

export const CONFIGURATION_FEATURE_KEY = 'common';

export interface CommonState {
  config: ConfigurationModel;
  user: UserModel;
}

export const INITIAL_STATE: CommonState = {
  config: null,
  user: null,
};

const commonReducer = createReducer(
  INITIAL_STATE,
  on(CommonActions.loadConfigurationSuccess, (state, action) => ({
    ...state,
    config: action.config,
  })),
  on(CommonActions.loadUserSuccess, (state, action) => ({
    ...state,
    user: action.user,
  })),
  on(createUidSuccess, (state, action) => ({
    ...state,
    user: { ...state.user, uid: action.uid },
  }))
);

export function reducer(state, action) {
  return commonReducer(state, action);
}
